import { render, staticRenderFns } from "./CategoryCaAndSessionDistributionChart.vue?vue&type=template&id=dc864116&"
import script from "./CategoryCaAndSessionDistributionChart.vue?vue&type=script&lang=js&"
export * from "./CategoryCaAndSessionDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports